import ESGComponentInner from '../../../SEO_pages/ESGComponent';

import Styles from './styles.module.scss';

const ESGComponent = () => (
  <div className={Styles.esg_holder}>
    <ESGComponentInner
      isWatchlists
    />
  </div>
);

export default ESGComponent;
